import types from './types'

export default {
  [types.mutations.SET_SELECTED_ROOM] (store, payload) {
    const id = payload;
    store.selectedRoomId = id;
  },
  [types.mutations.SET_SELECTED_DATE] (store, payload) {
    store.selectedDate = payload;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js